import React from 'react';
import EdenredTypo from '@sharedComponent/typography';
import SelectDropdown from '@pages/DesignSystem/ComboBox/SelectDropdown';
import { options2 } from '@pages/DesignSystem/Json/DesignSystem';
import '../SelectDropdown.scss';
const WithSubmenu = () => {
	return (
		<div style={{ width: '50%', paddingTop: '10px' }}>
			<EdenredTypo h2 bold style={{ fontSize: '18px' }}>
				With Sub Menu
			</EdenredTypo>
			<SelectDropdown
				className="select-dropdown-without-placeholder"
				onChange={(data) => console.log('datass', data)}
				Option={options2}
				placeholder="Sub Menu"
				searchVisibility={false}
			/>
		</div>
	);
};

export default WithSubmenu;
